import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { ROUTES } from '../../../../commons/routes/routes';
import jwt_decode from 'jwt-decode';
import { actions as userActions } from '../../../../redux/modules/usuario';
import { connect } from "react-redux";
import { compose } from 'redux';

class OAuth2RedirectHandler extends PureComponent {

    getUrlParameter(name) {
        // eslint-disable-next-line
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');

        var results = regex.exec(this.props.location.search);
        return results === null ? '' : decodeURIComponent(encodeURIComponent(results[1].replace(/\+/g, ' ')));
    }

    login = (token) => {
        const decodedToken = jwt_decode(token);
        //console.log('decodedToken___', decodedToken);
        const userStore = {
            authenticated: true,
            authorities: decodedToken.authorities,
            expires: decodedToken.exp,
            identificacao: decodedToken.sub,
            token: token,
            authProvider: decodedToken.provider
        };
        this.props.updateUserStore(userStore);
    }

    render() {
        const token = this.getUrlParameter('token');

        if (token) {
            this.login(token);
            const dynamicUrl = localStorage.getItem('dynamicRedirectUrl');
            const redirectTo = dynamicUrl ? ROUTES.OAUTH2_DYNAMIC_REDIRECT.path : ROUTES.SERVICOS_DISPONIVEIS.path;
            return <Redirect to={redirectTo} />;
        } else {
            return <Redirect to={ROUTES.LOGIN.path} />;
        }
    }

}

const mapDispatchToProps = {
    updateUserStore: userActions.updateUserStore,
};

export default compose(connect(null, mapDispatchToProps)) (OAuth2RedirectHandler);
